import { render, staticRenderFns } from "./SpecificationUpdate.vue?vue&type=template&id=18355f14&"
import script from "./SpecificationUpdate.vue?vue&type=script&lang=js&"
export * from "./SpecificationUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports